export default __webpack_public_path__ + "static/media/screen5.13a01289.png";